import SvgIcon from '@mui/material/SvgIcon';

const Desktops = (props) => {
    return (
        <SvgIcon {...props}>
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M19.9998 15.7363H18.3652V17.5633H19.9998C20.4806 17.5633 20.8652 17.1786 20.8652 16.6979C20.8652 16.2171 20.4806 15.8325 19.9998 15.8325V15.7363Z"
                    fill="white"
                />
                <path
                    d="M22.6931 2.73633H10.0008C9.03921 2.73633 8.17383 3.50556 8.17383 4.56325V7.25556H10.0008V4.56325H22.6931V10.9094H18.27V14.5633H22.6931C23.6546 14.5633 24.52 13.794 24.52 12.7363V4.56325C24.52 3.60171 23.7508 2.73633 22.6931 2.73633Z"
                    fill="white"
                />
                <path
                    d="M15.5763 8.48657H2.78786C1.82632 8.48657 0.960938 9.2558 0.960938 10.3135V18.3904C0.960938 19.352 1.73017 20.2173 2.78786 20.2173H7.78786L7.4994 21.0827H5.57632C5.09555 21.0827 4.71094 21.4673 4.71094 21.9481C4.71094 22.4289 5.09555 22.8135 5.57632 22.8135H12.884C13.3648 22.8135 13.7494 22.4289 13.7494 21.9481C13.7494 21.4673 13.3648 21.0827 12.884 21.0827H10.9609L10.6725 20.2173H15.6725C16.634 20.2173 17.4994 19.4481 17.4994 18.3904V10.3135C17.4994 9.35196 16.7302 8.48657 15.6725 8.48657H15.5763ZM15.5763 11.1789C15.5763 13.2817 15.5763 16.5635 15.5763 16.5635H2.78786V10.2173H15.4802H15.5763C15.5763 10.2173 15.5763 10.8034 15.5763 11.1789Z"
                    fill="white"
                />
            </svg>
        </SvgIcon>
    );
};

export default Desktops;
